import React from 'react';
import { BsTrash } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Flex, GridItem, Icon, IconButton, Image, Link, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getAttachmentDownloadUrl } from '../../../../api/portal-api';
import LoadingSpinner from '../../../../components/Spinner';
import { Statuses } from '../../../../constants/statuses';
import { showModal } from '../../../../redux/modules/modal';
import pinsTheme from '../../../../styles/theme';
import colors from '../../../../styles/theme/foundation/colors';
import { getDateString } from '../../../../utils/dateUtil';

import DeleteAttachmentModal from './DeleteAttachmentModal';

function AttachmentGridItem({ attachment }) {
  const dispatch = useDispatch();

  const confirmDelete = () => dispatch(showModal(
    () => <DeleteAttachmentModal attachment={attachment} />,
    {
      title: `Are you sure you want to delete ${attachment.name}?`
    }
  ));

  const openDownloadUrl = async () => {
    const response = await getAttachmentDownloadUrl(attachment.id);
    window.open(response.url, '_blank');
  };

  return (
    <GridItem
      alignItems="center"
      as={Flex}
      borderRadius="16px"
      height="150px"
      justifyContent="center"
      overflow="hidden"
      padding="5px"
      pos="relative"
      width="150px"
    >
      {
        attachment.status === Statuses.Uploading
          ? <LoadingSpinner isInline />
          : (
            <>
              <Image
                alt="attachment thumbnail"
                borderRadius="16px 16px 0 0"
                src={attachment.mediumThumbnailUrl}
                width="100%"
              />
              <Box
                backgroundColor={pinsTheme.colors.greyScale[600]}
                borderRadius="16px"
                bottom={0}
                left={0}
                opacity={0.4}
                pos="absolute"
                right={0}
                top={0}
              />
              <Tooltip label="Delete Attachment">
                <IconButton
                  aria-label="delete attachment"
                  bgColor={colors.greyScale[200]}
                  border="none"
                  icon={<Icon as={BsTrash} h="24px" w="24px" />}
                  pos="absolute"
                  right="5px"
                  size="navIcon"
                  top="5px"
                  variant="accentError"
                  onClick={confirmDelete}
                />
              </Tooltip>
              <Tooltip label="Download Attachment">
                <Box cursor="pointer" onClick={openDownloadUrl}>
                  <Box
                    bgColor={colors.greyScale[100]}
                    borderRadius="16px"
                    bottom="2px"
                    fontSize="xs"
                    left="2px"
                    maxW="100%"
                    overflow="hidden"
                    padding="8px"
                    position="absolute"
                    right="2px"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                  >
                    <Box fontWeight="bold" maxW="95%" overflow="hidden" textOverflow="ellipsis">{attachment.name}</Box>
                    <Box>{getDateString(attachment.createdAt)}</Box>
                  </Box>
                </Box>
              </Tooltip>
            </>
          )
    }
    </GridItem>
  );
}

AttachmentGridItem.propTypes = {
  attachment: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    smallThumbnailUrl: PropTypes.string,
    mediumThumbnailUrl: PropTypes.string,
    largeThumbnailUrl: PropTypes.string,
    createdAt: PropTypes.string,
    status: PropTypes.string
  })
};

export default AttachmentGridItem;
